function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
import React from "react";
import { styled } from "../imports";
import Box from "./Box";
import { minmaxProp } from "../utils";
var filterProps = function filterProps(Component) {
  return function (_ref) {
    var min = _ref.min,
      max = _ref.max,
      props = _objectWithoutProperties(_ref, ["min", "max"]);
    return React.createElement(Component, props);
  };
};
var Break = /*#__PURE__*/styled(filterProps(Box.is("br")), {
  label: "Break",
  target: "css-3qwt5b0"
})("display:none;", minmaxProp("display:block"), ";");
Break.displayName = "Break";
export default Break;